import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Image from 'next/image';
import cx from 'classnames';
import { HERO_PRICE_COMPARISON } from '@config/savings-stats';
const priceClassName = 'font-medium text-white text-[28px] leading-[35px] lg:text-h3';
interface HeroPriceComparisonProps {
  className?: string;
}
export const HeroPriceComparison: React.FC<HeroPriceComparisonProps> = t0 => {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="sr-only">{`The same stay costs ${HERO_PRICE_COMPARISON.airbnb} on Airbnb and ${HERO_PRICE_COMPARISON.savvy} on Savvy.`}</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col items-center gap-0.5 lg:gap-2"><Image src="/assets/svg/logos/airbnb_wordmark_coral.svg" alt="Airbnb" width={238} height={74} className="h-auto w-[140px] lg:w-[237px]" /><s className={cx(priceClassName, "decoration-white decoration-[3px] lg:decoration-[5px]")}>{HERO_PRICE_COMPARISON.airbnb}</s></div>;
    t3 = <div className="h-[82px] w-0.5 bg-gray-light lg:h-[142px] lg:w-1" />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div aria-hidden="true" className="flex items-end gap-7 lg:gap-12" data-id="hero-price-comparison">{t2}{t3}<div className="flex flex-col items-start gap-[5px] lg:gap-3"><Image src="/assets/svg/logos/savvy_wordmark_seafoam.svg" alt="Savvy" width={1944} height={732} className="h-[34px] w-auto lg:h-[60px]" /><span className={priceClassName}>{HERO_PRICE_COMPARISON.savvy}</span></div></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== className) {
    t5 = <div className={className}>{t1}{t4}</div>;
    $[4] = className;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};